module.exports = __webpack_public_path__ + "img/211.3ad687ec.jpg";